import React, { useState, Fragment } from 'react';
import { Row, Modal, ModalHeader, ModalBody, Button, Collapse } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { faLink, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Message from '../Message/Message';
import Link from '../Link/Link';
import Example from '../Example/Example'
import {
  AddMessageButton,
  DisabledAddLinkButton,
  DeleteButton,
  DisabledAddImageButton,
  AddApiButton,
  DisabledAddVideoButton
} from '../Button/AddButton';
import ResponseInformation from './ResponseInformation';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { putAPI_Delete_Response } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import BotResponseButton from '../ApiButtons/BotResponseButton';

import ChildButtonsResponse from './ChildButtonsResponse';
function LinkResponse({
  reloadBotResponse,
  elem,
  /** Globle property id from redux */
  propertyId,
  child,
  SaveRecommenderQuestionCode,
  DeleteQuestion,
  QuestionId,
  locale,
  favouriteResponse,
  showFav
}) {
  const [isAddMsg, setIsAddMsg] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [isAddApiButton, setIsAddApiButton] = useState(false);
  const [isEditingButtonText, setIsEditingButtonText] = useState(false);

  //console.log(elem)
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const toggleButtonText = () => {
    setIsEditingButtonText(!isEditingButtonText);
  };
  const toggleButtonAddedd = () => {
    //  setIsButtonAddedd(!isButtonAddedd);
    //setIsAddApiButton(false)
    // reloadBotResponse()
    toggleButtonText()
  };
  const toggleButtonMessageAddedd = () => {

  }
  const handleDelete = code => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Response}/${code}`,
      data: {
        GroupId: getGroupID(),
        PropertyId: propertyId,
        Language: `${locale === 'en' ? 'en-US' : locale}`,
        Channel: 'WebsiteDirectLine',
      },
    })
      .then(res => {
        // console.log(res.data);
        toggle();
      })
      .finally(
        setTimeout(() => {
          if (DeleteQuestion !== undefined) {
            DeleteQuestion(QuestionId)
          }
          else {
            reloadBotResponse();
          }
        }, 1000)
      )
      .catch(err => {
        console.log(err);
      });
  };

  // const handleDeleteButton = (code, messages, url, caption, button, buttonCode) => {
  //   let postData = {
  //     GroupId: getGroupID(),
  //     Code: code,
  //     Language: 'en-US',
  //     Channel: 'WebsiteDirectLine',
  //     PropertyId: propertyId,
  //     Default: {
  //       Messages: messages,
  //       Url: url,
  //       Caption: caption,
  //       apiButton: { text: button.query.buttonText, value: button.query.code, deleted: true }
  //     },
  //     Overrides: {},
  //   }
  //   AxiosAPI({
  //     method: 'put',
  //     url: `${putAPI_Update_Response}`,
  //     data: postData,
  //   })
  //     .then(() => {
  //       console.log("aa")
  //     })
  //     .finally(
  //       setTimeout(() => {
  //         toggleButtonAddedd();
  //         reloadBotResponse();
  //       }, 1000)
  //     );
  // }


  // const renderSwitch = (button, index) => {
  //   switch (button.response.type) {
  //     case 'example':
  //       return (
  //         <Fragment key={index}>
  //           <ExampleResponse
  //             elem={{ ...button }}
  //             reloadBotResponse={reloadBotResponse}
  //             child={1}
  //           />
  //         </Fragment>
  //       );

  //     case 'messages':
  //       return (
  //         <Fragment key={index}>
  //           <MessageResponse
  //             elem={{ ...button }}
  //             reloadBotResponse={reloadBotResponse}
  //             child={1}
  //           />
  //         </Fragment>
  //       );

  //     case 'messages-link':
  //       return (
  //         <Fragment key={index}>
  //           <LinkResponse
  //             elem={{ ...button }}
  //             reloadBotResponse={reloadBotResponse}
  //             child={1}
  //           />
  //         </Fragment>
  //       );

  //     case 'messages-image-carousel':
  //       return (
  //         <Fragment key={index}>
  //           <ImageCarouselResponse
  //             elem={{ ...button }}
  //             reloadBotResponse={reloadBotResponse}
  //             child={1}
  //           />
  //         </Fragment>
  //       );

  //     default:
  //       break;
  //   }
  // }

  const generateButtonGroup = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="2" className="mb-1">
              <div
                onClick={() => {
                  setIsAddMsg(true);
                }}
              >
                <AddMessageButton className="add-button" />
              </div>
            </Colxx>
            <Colxx xs="12" sm="2" className="mb-1">
              <DisabledAddLinkButton className="add-button" disabled={true} />
            </Colxx>
            <Colxx xs="12" sm="2" className="mb-1">
              <DisabledAddImageButton className="add-button" disabled={true} />
            </Colxx>
            {child === undefined && (<Colxx xs="12" sm="2" className="mb-1">
              <div
                onClick={() => {
                  setIsAddApiButton(true);
                }}
              >
                <AddApiButton className="add-button" />
              </div>
            </Colxx>)}
            <Colxx xs="12" sm="2" className="mb-1">
              <DisabledAddVideoButton className="add-button" disabled={true} />
            </Colxx>
            <Colxx xs="12" sm="2" className="mb-1">
              <div onClick={toggle}>
                <DeleteButton className="add-button" />
              </div>
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This response will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete(elem.query.code)}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  let idxCount = -1;
  return (
    <Row>
      <Colxx xxs="12" xs="3">
        {child === undefined && (<ResponseInformation elem={elem} favouriteResponse={favouriteResponse} reloadBotResponse={reloadBotResponse} showFav={showFav} />)}
      </Colxx>
      <Colxx xxs="12" xs={child === undefined ? "9" : "12"}>
        <Row>
          <Colxx md="12" className="mb-2">
            {elem.response.messages.map((msg, index) => {
              idxCount++;
              return (
                <Message
                  key={index}
                  index={index}
                  code={elem.query.code}
                  type={elem.response.type}
                  msg={msg}
                  messages={elem.response.messages}
                  example={elem.response.example}
                  link={elem.response.details.url}
                  caption={elem.response.details.caption}
                  numberOfMsg={elem.response.numberOfMsg}
                  reloadBotResponse={reloadBotResponse}
                  SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                />
              );
            })}
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-2">
            <Link
              messages={elem.response.messages}
              code={elem.query.code}
              link={elem.response.details.url}
              caption={elem.response.details.caption}
              reloadBotResponse={reloadBotResponse}
              SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
            />
          </Colxx>
        </Row>
        {isAddMsg ? (
          <Row>
            <Colxx md="12" className="mb-2">
              <Message
                isAdd={isAddMsg}
                code={elem.query.code}
                type={elem.response.type}
                msg={''}
                messages={elem.response.messages}
                index={idxCount + 1}
                example={elem.response.example}
                setIsAddMsgToFalse={() => setIsAddMsg(false)}
                numberOfMsg={0}
                link={elem.response.details.url}
                caption={elem.response.details.caption}
                reloadBotResponse={reloadBotResponse}
                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
              />
            </Colxx>
          </Row>
        ) : null}
        {generateButtonGroup()}
        <Collapse isOpen={isAddApiButton}>
          <Row>
            <Colxx md="6" className="mb-2">
            </Colxx>
            <Colxx md="5" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
              <BotResponseButton
                link={elem.response.details.url}
                caption={elem.response.details.caption}
                isAdd={isAddApiButton}
                index={0}
                code={elem.query.code}
                messages={elem.response.messages}
                setIsAddImageToFalse={() => setIsAddApiButton(false)}
                reloadBotResponse={reloadBotResponse}
                type={"link"}
                toggleButtonAddedd={toggleButtonAddedd}
                buttonText={""}
                buttonValue={""}
                toggleButtonMessageAddedd={toggleButtonMessageAddedd}
              />
            </Colxx>
            <Colxx md="1" className="mb-2">
            </Colxx>
          </Row>
        </Collapse>

        {elem.apiButtons !== undefined && elem.apiButtons.length > 0 ? (
          <Fragment>
            {elem.apiButtons.map((button, index) => {
              return (
                <ChildButtonsResponse elem={elem} button={button} index={index} reloadBotResponse={reloadBotResponse} propertyId={propertyId} type={"link"} locale={locale} />)
            })}
          </Fragment>
        ) : null}
        {/* {elem.apiButtons !== undefined && elem.apiButtons.length > 0 ? (
          <Fragment>
            {elem.apiButtons.map((button, index) => {
              return (
                <Colxx xxs="12" xs="12" style={{ border: 'solid 1px', margin: '5px' }} >
                  <h3 style={{ display: 'inline-block', marginRight: '10px' }}>{button.query.buttonText}</h3>
                  <FontAwesomeIcon
                    icon={faEdit}
                    color="#90caf9"
                    cursor="pointer"
                    onClick={toggleButtonText}
                  />

                  <b> | </b>
                  <FontAwesomeIcon
                    icon={faTrashAlt}
                    color="#e57373"
                    cursor="pointer"
                    onClick={() => handleDeleteButton(elem.query.code, elem.response.messages, elem.response.details.url, elem.response.details.caption, button)}
                  />
                  {isEditingButtonText && (<BotResponseButton
                    link={elem.response.details.url}
                    caption={elem.response.details.caption}
                    isAdd={isAddApiButton}
                    index={0}
                    code={elem.query.code}
                    messages={elem.response.messages}
                    setIsAddImageToFalse={() => setIsAddApiButton(false)}
                    reloadBotResponse={reloadBotResponse}
                    type={"link"}
                    toggleButtonAddedd={toggleButtonAddedd}
                    buttonText={button.query.buttonText}
                    buttonValue={button.query.code}
                  />)}

                  {renderSwitch(button, index)}
                </Colxx>)
            })}
          </Fragment>
        ) : null} */}
        {/* {isButtonAddedd ? (
          <Colxx xxs="12" xs="12">
            <h3>Opening Hours</h3>
            <Row>
              <Colxx md="12" className="mb-2">
                <Example example={""} />
              </Colxx>
            </Row>
            {isAddButtonMsg ? (
              <Row>
                <Colxx md="12" className="mb-2">
                  <Message
                    isAdd={isAddButtonMsg}
                    code={elem.query.code}
                    type={elem.response.type}
                    msg={''}
                    messages={""}
                    index={0}
                    example={""}
                    setIsAddMsgToFalse={() => setIsAddMsg(false)}
                    reloadBotResponse={reloadBotResponse}
                  />
                </Colxx>
              </Row>
            ) : null}
            {generateButtonGroupNew()}
          </Colxx>) : null} */}

      </Colxx>
    </Row>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps)(LinkResponse));
